import type { FreightPickupPoint } from '../useFreightSimulation'
import { PickupPointCard } from './PickupModalCard'

export const PickupPointList = ({
  pickupPoints,
  title,
  isTitleVisible = true,
  handleCloseModal,
}: {
  pickupPoints: FreightPickupPoint[]
  title: string
  isTitleVisible?: boolean
  handleCloseModal: () => void
}) => {
  if (pickupPoints.length === 0) {
    return null
  }

  return (
    <div>
      {isTitleVisible && (
        <p className="text-base font-semibold text-restructure-primary text-center">
          {title}
        </p>
      )}
      <ul
        className={`flex flex-col gap-4 px-[8.5px] list-none ${
          isTitleVisible ? 'mt-8' : ''
        }`}
      >
        {pickupPoints.map((pickupPoint) => {
          const { name, distance, address, shippingEstimate, price } =
            pickupPoint

          return (
            <PickupPointCard
              key={name}
              name={name}
              distance={distance}
              address={address}
              shippingEstimate={shippingEstimate}
              price={price}
              handleCloseModal={handleCloseModal}
            />
          )
        })}
      </ul>
    </div>
  )
}
